import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const PlayIcon = ({ width = 30, height = 30 }) => (
  <PlaySvg width={width} height={height} viewBox="0 0 11 14">
    <path d="M0 0V14L11 7L0 0Z" />
  </PlaySvg>
);

PlayIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const PlaySvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(PlayIcon);
